import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getMobilization = createAsyncThunk("api/mobilization", async (token) => {
  try {
    const response = await nodeinstance.get("/mobilization", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const MobilizationDataSlice = createSlice({
  name: "mobilization",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMobilization.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getMobilization.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getMobilization.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getMobilization };
export default MobilizationDataSlice.reducer;
